var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localShow)?_c('div',{class:( _obj = {}, _obj[_vm.$s.popup] = true, _obj[_vm.$s.isError] = _vm.params.isError, _obj ),style:(_vm.style)},[_vm._v(_vm._s(_vm.params.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }